import React from 'react';

const layout = (props) => {
    return (
        <main>
            {props.children}
        </main>
    );
};

export default layout;